import CalculatorOptions from './calculator-options';

export default CalculatorOptions;
